var _rect, _path, _path2, _path3, _path4, _path5, _rect2, _path6, _path7, _rect3, _rect4, _path8, _ellipse, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewBusy(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 136,
    viewBox: "0 0 136 136",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 136,
    height: 136,
    rx: 8,
    fill: "#F5BBBD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.2266 35.2211C43.2266 21.9674 53.9707 11.2233 67.2244 11.2233C80.478 11.2233 91.2222 21.9674 91.2222 35.2211V86.5582H43.2266V35.2211Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M115.806 136H18.6431L23.418 97.4954C24.3667 89.8448 30.0507 83.683 37.3781 81.287C46.6736 78.2473 57.8074 73.44 57.8074 67.8508C57.8074 63.4716 57.1999 55.5736 57.1999 55.5736L77.2487 54.9661C77.2487 54.9661 76.6412 63.1764 76.6412 67.5768C76.6412 73.3267 87.7793 78.2014 97.0758 81.2688C104.397 83.6843 110.082 89.8449 111.031 97.4954L115.806 136Z",
    fill: "#CD8B52"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M115.806 136H18.6431L23.418 97.4954C24.3667 89.8448 30.0507 83.683 37.3781 81.2869C40.5201 80.2595 43.8722 79.03 46.9334 77.6367C51.5236 81.3393 58.5195 85.252 67.5281 85.167C76.4435 85.0828 83.2209 81.2595 87.6541 77.6371C90.6793 79.0252 93.9797 80.2472 97.0758 81.2688C104.397 83.6843 110.082 89.8448 111.031 97.4954L115.806 136Z",
    fill: "#031D43"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M65.0486 136H38.2015L37.2695 81.3228C37.3057 81.3107 37.342 81.2988 37.3783 81.2869C41.2951 80.0061 45.5383 78.4114 49.1375 76.5767L65.0486 136Z",
    fill: "#338DE3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.7393 96.8854C46.2889 96.8854 45.9313 97.1346 45.9313 97.4363L46.2094 100.512C46.2359 100.696 46.4677 100.84 46.7393 100.84C47.0175 100.84 47.2493 100.696 47.2824 100.512L47.554 97.4363C47.554 97.1346 47.1963 96.8854 46.7393 96.8854ZM42.4938 99.4039C42.2288 99.253 41.8314 99.4367 41.6063 99.8236C41.3744 100.211 41.4142 100.643 41.6857 100.794L44.5072 102.099C44.6861 102.159 44.9245 102.034 45.0636 101.798C45.2027 101.562 45.1894 101.293 45.0437 101.175L42.4938 99.4039ZM51.8061 100.794C52.071 100.643 52.1108 100.211 51.8856 99.8236C51.6538 99.4367 51.2564 99.253 50.9914 99.4039L48.4415 101.175C48.2958 101.293 48.2825 101.562 48.4216 101.798C48.5607 102.034 48.7991 102.159 48.978 102.099L51.8061 100.794ZM41.6857 104.723C41.4142 104.88 41.3744 105.313 41.6063 105.7C41.8314 106.087 42.2288 106.271 42.4938 106.12L45.0437 104.349C45.1894 104.224 45.2027 103.956 45.0636 103.719C44.9245 103.483 44.6861 103.359 44.5072 103.424L41.6857 104.723ZM48.978 103.424C48.7991 103.359 48.5607 103.483 48.4216 103.719C48.2825 103.956 48.2958 104.224 48.4415 104.349L50.9914 106.12C51.2564 106.271 51.6538 106.087 51.8856 105.7C52.1108 105.313 52.071 104.88 51.8061 104.723L48.978 103.424ZM46.7459 104.684C46.4677 104.684 46.2359 104.821 46.2094 105.005L45.9313 108.081C45.9313 108.389 46.2889 108.638 46.7393 108.638C47.1963 108.638 47.554 108.389 47.554 108.081L47.2824 105.005C47.2493 104.821 47.0175 104.684 46.7459 104.684Z",
    fill: "#FFE190"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 41.063,
    y: 111.255,
    width: 11.3613,
    height: 4.30946,
    rx: 1.18683,
    fill: "#E8E8E8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M96.4213 136H69.5742L85.483 76.5854C89.0466 78.4132 93.2196 79.9965 97.0757 81.2688C97.1683 81.2993 97.2606 81.3305 97.3526 81.3622L96.4213 136Z",
    fill: "#338DE3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M51.7319 32.791C51.7319 24.2348 58.6681 17.2987 67.2242 17.2987C75.7803 17.2987 82.7164 24.2348 82.7164 32.791V49.1945C82.7164 57.7507 75.7803 64.6868 67.2242 64.6868C58.6681 64.6868 51.7319 57.7507 51.7319 49.1945V32.791Z",
    fill: "#CD8B52"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 77.8564,
    y: 39.17,
    width: 9.1131,
    height: 9.11309,
    rx: 4.55655,
    fill: "#CD8B52"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 47.4795,
    y: 39.17,
    width: 9.11309,
    height: 9.11309,
    rx: 4.55655,
    fill: "#CD8B52"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.7319 19.7288L66.9204 14.261L82.7164 19.7288L84.5391 24.5892L82.7164 27.6897C82.7164 27.6897 76.0978 29.5159 68.743 34.6031C61.3882 39.6903 51.7319 42.2078 51.7319 42.2078L49.3018 30.6646L51.7319 19.7288Z",
    fill: "black"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 75.4261,
    cy: 47.0681,
    rx: 1.82262,
    ry: 1.82262,
    fill: "black"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 59.0223,
    cy: 47.0681,
    r: 1.82262,
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewBusy);
export default __webpack_public_path__ + "static/media/newBusy.432f7e2716bf7973eb8efbf34da67a13.svg";
export { ForwardRef as ReactComponent };